import { TQuickinfoType } from 'gql'
import { Link } from 'react-router'
import { CookieBannerLink, I18nHtml, Quickinfo, Routes, t } from 'shared'
import GoodCrowdLogo from '../../../assets/images/goodcrowd-busy.svg'
import LanguageSwitcher from 'shared/components/language_switcher'

const Footer = () => (
  <footer className="me-footer">
    <div className="flex flex-col mx-4">
      <ul className="text-list text-center">
        <li>
          <a href={Routes.aboutUsPath()}>{t('link_titles.about_us')}</a>
        </li>
        <li>
          <a href={Routes.pricingPath()}>{t('link_titles.fees')}</a>
        </li>
        <li>
          <a href="/blog">Blog</a>
        </li>
        <li>
          <a href={Routes.helpPath()}>{t('link_titles.help')}</a>
        </li>
        <li>
          <Link to={Routes.usagePath()}>{t('link_titles.how_it_works')}</Link>
        </li>
        <li>
          <a href={Routes.termsGeneralPath()}>{t('link_titles.terms_of_service')}</a>
        </li>
        <li>
          <a href={Routes.privacyPath()}>{t('link_titles.privacy_policy')}</a>
        </li>
        <li>
          <a href={Routes.imprint()}>{t('link_titles.imprint')}</a>
        </li>
        <li>
          <Link to={Routes.termsRevocationPath()}>{t('link_titles.cancellation_policy')}</Link>
        </li>
        <li>
          <a href={Routes.accessibilityPath()}>{t('link_titles.accessibility')}</a>
        </li>
        <li>
          <CookieBannerLink content={t('link_titles.cookie_settings')} />
        </li>
      </ul>

      <div className="flex flex-col lg:flex-row justify-between items-center lg:items-end gap-y-9">
        <img src={GoodCrowdLogo} alt="GoodCrowd.org logo" className="ui image logo" />
        <Quickinfo type={TQuickinfoType.Dev} placement="bottom" />
        <div className="flex flex-col gap-2 items-center md:items-end">
          <div>
            <I18nHtml i18nKey="socials_html" />
          </div>
          <LanguageSwitcher />
        </div>
      </div>
    </div>
  </footer>
)

export default Footer
